// スムーススクロール
$('a[href^="#"]').on("click", function () {
  const speed = 500;
  const href = $(this).attr("href");
  const target = $(href == "#" || href == "" ? "html" : href);
  const position = target.offset().top;
  $("html, body").animate({ scrollTop: position }, speed);
  return false;
});

// ハンバーガーメニュー
$(document).ready(function() {
  $('.js-nav-bt').on('click', function (e) {
    e.preventDefault();
    console.log('ハンバーガーボタンクリック');
    $(".js-nav-content, .js-nav-logo, .js-nav-bt, .js-header-sp").toggleClass('is-navOn');
    console.log('is-navOnクラス追加:', $('.js-nav-bt').hasClass('is-navOn'));
  });

  // ナビリンククリック時にメニューを閉じる
  $('.js-nav-link').on('click', function () {
    $(".js-nav-content, .js-nav-logo, .js-nav-bt, .js-header-sp").removeClass('is-navOn');
  });
});
